import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import RemoveButton from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/RemoveButton';

const styles = () => ({
  root: {},
  header: {},
  fields: {},
  footer: {},
});

function DefaultLayout({
  classes,
}) {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      <SurveyStepHeader
        className={classes.header}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      {resource.meta().canDelete()
        && (<RemoveButton
          resource={resource}
          test="remove-item-button"
        />)
      }
      <SurveyStepFooter
        className={classes.footer}
        onSubmit={onSubmitMetaForm}
      />
    </div>
  );
}

DefaultLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

DefaultLayout.defaultProps = {
};

export default withStyles(styles)(DefaultLayout);
